import { cn } from "@/shared/lib/cn";

import { BrandMark } from "./BrandMark";

interface LogoProps {
  /** Pixel height of the lockup (mark + wordmark scale together). */
  height?: number;
  className?: string;
  /** Optional accessible label override. Defaults to "PayGate LogistiX". */
  alt?: string;
}

/**
 * PayGate LogistiX name logo — the "P" arrow mark beside the stacked
 * "PayGate / LogistiX" wordmark. Live text (Plus Jakarta Sans) instead of a
 * bitmap so it stays crisp, themes correctly, and needs no asset download.
 * Use in the app header and the login-card header; for hero surfaces with
 * the tagline use `<LogoFull>`.
 */
export function Logo({ height = 32, className, alt = "PayGate LogistiX" }: LogoProps) {
  // The wordmark ink is the fixed brand violet on light surfaces; dark mode
  // falls back to the foreground token for contrast.
  return (
    <span
      className={cn("inline-flex select-none items-center", className)}
      style={{ gap: height * 0.28 }}
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
    >
      <BrandMark size={height} label="" />
      <span
        aria-hidden
        className="flex flex-col font-extrabold leading-none tracking-tight text-[#2f1e55] dark:text-foreground"
        style={{ fontSize: height * 0.44, gap: height * 0.08 }}
      >
        <span>PayGate</span>
        <span>LogistiX</span>
      </span>
    </span>
  );
}
